export const BRADMAX_PLAYER_VERSION = 'v2.5.0';